export var LoadingText;
(function (LoadingText) {
    LoadingText["DEFAULT"] = "Loading...";
    LoadingText["CALCULATING"] = "Calculating total...";
    LoadingText["COMPLETING"] = "Completing order...";
})(LoadingText || (LoadingText = {}));
export var SuccessStatusText;
(function (SuccessStatusText) {
    SuccessStatusText["CHANGES_SAVED"] = "Changes Saved";
    SuccessStatusText["PAYMENT_COMPLETE"] = "Payment Complete";
})(SuccessStatusText || (SuccessStatusText = {}));
export var ActionButtonText;
(function (ActionButtonText) {
    ActionButtonText["CANCEL"] = "CANCEL";
    ActionButtonText["CONFIRM"] = "CONFIRM";
    ActionButtonText["OK"] = "OK";
})(ActionButtonText || (ActionButtonText = {}));
